import { useMemo, useState, useCallback } from 'react';

export interface OrderFiltersState {
  nation: string;
  payment_status: string;
  applicant_name: string;
  contact_name: string;
  channel: string;
  source: string;
  status: string;
  seller: string;
  date_field: string;
  date_from: string;
  date_to: string;
}

export interface UseOrderFiltersResult {
  searchText: string;
  searchField: string;
  setSearchField: (v: string) => void;
  setSearchText: (v: string) => void;
  filters: OrderFiltersState;
  setFilters: (updater: (prev: OrderFiltersState) => OrderFiltersState) => void;
  handleFilterChange: (key: keyof OrderFiltersState, value: string) => void;
  handleResetFilters: () => void;
}

export function useOrderFilters(): UseOrderFiltersResult {
  const [searchText, setSearchText] = useState('');
  const [searchField, setSearchField] = useState('all');
  const [filtersState, setFiltersState] = useState<OrderFiltersState>({
    nation: '',
    payment_status: '',
    applicant_name: '',
    contact_name: '',
    channel: '',
    source: '',
    status: '',
    seller: '',
    date_field: '',
    date_from: '',
    date_to: '',
  });

  const filters = useMemo(() => filtersState, [
    filtersState.nation,
    filtersState.payment_status,
    filtersState.applicant_name,
    filtersState.contact_name,
    filtersState.channel,
    filtersState.source,
    filtersState.status,
    filtersState.seller,
    filtersState.date_field,
    filtersState.date_from,
    filtersState.date_to,
  ]);

  const handleFilterChange = useCallback((key: keyof OrderFiltersState, value: string) => {
    setFiltersState(prev => ({ ...prev, [key]: value }));
  }, []);

  const handleResetFilters = useCallback(() => {
    setFiltersState({
      nation: '',
      payment_status: '',
      applicant_name: '',
      contact_name: '',
      channel: '',
      source: '',
      status: '',
      seller: '',
      date_field: '',
      date_from: '',
      date_to: '',
    });
    setSearchText('');
    setSearchField('all');
  }, []);

  const setFilters = useCallback((updater: (prev: OrderFiltersState) => OrderFiltersState) => {
    setFiltersState(prev => updater(prev));
  }, []);

  return { searchText, setSearchText, searchField, setSearchField, filters, setFilters, handleFilterChange, handleResetFilters };
}
